(function () {
    'use strict';

    angular.module('swif.patrimoine')
    .config(route)
    .factory('swifPatrimoineReferentielService', swifPatrimoineReferentielService)
    .controller('PatrimoineReferentielController', PatrimoineReferentielController)
    .directive('listGroupItemPatrimoineSite', listGroupItemPatrimoineSite);


    function route($routeProvider) {
        'ngInject';
        $routeProvider.when('/patrimoine/patrimoine/explorer_view', {
            templateUrl: 'partials/patrimoine/patrimoine_explorer_view.html',
            controller: 'PatrimoineReferentielController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifPatrimoineReferentielService', function (service) {
                    return service.resolveLeaflet();

                }]
            }
        });
        $routeProvider.when('/patrimoine/patrimoine/maps_view', {
            templateUrl: 'partials/patrimoine/patrimoine_maps_view.html',
            controller: 'PatrimoineReferentielController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifPatrimoineReferentielService', function (service) {
                    return service.resolveLeaflet();
                }]
            }
        });
    }

    /**
        * @ngdoc service
        * @name swif.patrimoine.swifPatrimoineReferentielService
        * @requires swif.framework.swifFrameworkService
        * @requires swif.openbase.swifOpenbaseService
    **/
    function swifPatrimoineReferentielService($q, $location, swif, openbase, patrimoinePropertyService, gettextCatalog) {
        'ngInject';
        var service = {
            data: {},
            swif: swif
        };

        service.resolveLeaflet = function () {
            return swif.route.check({resources: ['leaflet', 'd3']})
                .then(function () {
                    return resolveData();
                });
        };

        function resolveData() {
            var deferred = $q.defer();
            var data = {};
            var siteString = gettextCatalog.getString('Site');
            var equipString = gettextCatalog.getString('Equipment');

            data.title = 'Referentiel patrimonial';
            data.actionViewsCategory = 'views';
            data.select = {
                patrimoine_types: [
                    ['patrimoine_site', siteString],
                    ['patrimoine_equipment', equipString]
                ]
            };
            patrimoinePropertyService.is_parcauto = false;
            data.patrimoine_type = $location.search().patrimoine_type || 'patrimoine_site';
            service.createCollection(data.patrimoine_type).then(function (collection) {
                data.referentiel = collection;
                if (data.referentiel.currentItem && data.referentiel.currentItem._type !== data.patrimoine_type) {
                    data.referentiel.currentItem = undefined;
                }
                service.data.referentiel = data.referentiel;
                deferred.resolve(data);
            });
            return deferred.promise;
        };

        service.createCollection = function (typeOfPatrimoine, filter) {
            if (filter === undefined) {
                filter = service.getCollectionFilter(typeOfPatrimoine);
            }
            return swif.collections.createOrUpdate(
                'patrimoine_referentiel',
                typeOfPatrimoine,
                filter,
                {location: true}
            );
        };
        service.getCollectionFilter = function (typeOfPatrimoine) {
            var filter = {};
            swif.data.sortOn(filter, 'name', 'ASC');
            if (typeOfPatrimoine === 'patrimoine_site') {
                swif.data.addFilter(filter, 'site_parent_id', '=', false);
            }
            return filter;

        };
        service.getCollection = function () {
            return swif.collections.getCollection('patrimoine_referentiel');
        };

        service.preModal = function (data) {
            service.getCollection().preModal(data);
        };
        service.preValidate = function (data) {
            openbase.customfields.sanitize(data);
            return service.getCollection().preValidate(data);
        };
        service.callback = function (error, data) {
            service.getCollection().defaultActionCallback(error, data);
            if (data) {
                if (data.model._type === 'patrimoine_equipment') {
                    openbase.equipment.callback(error, data);
                }
            }
        };
        service.getFilters = function (model) {
            var filters = {};
            filters = {
                cadastre_section: {},
                cadastre_feuille: {}
            };
            if (model) {
                var c = model.cadastre_commune;
                if (c) {
                    swif.data.addFilter(
                        filters.cadastre_section, 'commune', '=', c[0]
                    );
                    swif.data.addFilter(
                        filters.cadastre_feuille, 'commune', '=', c[0]
                    );
                }
            }
            return filters;
        };
        service.getSuiviParams = function (patrimoine) {
            var params = {
                requests: {
                    contentType: 'intervention_request',
                    groupBy: 'intervention_assignement_id',
                    filter: {},
                    defaultLabel: 'Without category',
                    groupByLabel: 'Category',
                    states: ['wait', 'to_confirm', 'valid', 'refused', 'finished'],
                    modal: {
                        title: 'Requests',
                        templateUrl: 'partials/patrimoine/requests_table_modal.html'
                    }
                },
                interventions: {
                    contentType: 'intervention',
                    groupBy: 'intervention_assignement_id',
                    filter: {},
                    defaultLabel: 'Without category',
                    groupByLabel: 'Category',
                    states: ['open', 'scheduled', 'pending', 'cancelled', 'finished'],
                    modal: {
                        title: 'Interventions',
                        templateUrl: 'partials/patrimoine/interventions_table_modal.html'
                    }
                },
                tasks: {
                    contentType: 'task',
                    groupBy: 'category_id',
                    filter: {},
                    defaultLabel: 'Without category',
                    groupByLabel: 'Category',
                    states: ['draft', 'open', 'pending', 'done'],
                    modal: {
                        title: 'Tasks',
                        templateUrl: 'partials/patrimoine/tasks_table_modal.html'
                    }
                },
                contractTasks: {
                    contentType: 'patrimoine_contract_task',
                    groupBy: 'project_id',
                    filter: {domain: [['project_id.is_contract', '=', true]]},
                    defaultLabel: 'Without contracts',
                    groupByLabel: 'Contracts',
                    states: ['draft', 'open', 'pending', 'done'],
                    modal: {
                        title: 'Tasks',
                        templateUrl: 'partials/patrimoine/tasks_table_modal.html'
                    }
                },
                controlTasks: {
                    contentType: 'patrimoine_contract_task',
                    groupBy: 'project_id',
                    filter: {domain: [['project_id.is_control', '=', true]]},
                    defaultLabel: 'Without controls',
                    groupByLabel: 'Controls',
                    states: ['draft', 'open', 'pending', 'done'],
                    modal: {
                        title: 'Tasks',
                        templateUrl: 'partials/patrimoine/tasks_table_modal.html'
                    }
                }
            };
            if (patrimoine) {

                swif.data.addFilter(params.controlTasks.filter, 'project_id.project_type', '=', 'contract');
                swif.data.addFilter(params.contractTasks.filter, 'project_id.project_type', '=', 'contract');
                if (patrimoine._type === 'patrimoine_site' || patrimoine._type === 'site') {
                    swif.data.addFilter(params.requests.filter, 'site1', 'child_of', [patrimoine.id]);
                    swif.data.addFilter(params.interventions.filter, 'site1', 'child_of', [patrimoine.id]);
                    swif.data.addFilter(params.tasks.filter, '|');
                    swif.data.addFilter(params.tasks.filter, 'site1', 'child_of', [patrimoine.id]);
                    swif.data.addFilter(params.tasks.filter, 'project_id.site1', 'child_of', [patrimoine.id]);
                    swif.data.addFilter(params.contractTasks.filter, 'project_id.site_ids', 'child_of', [patrimoine.id]);
                    swif.data.addFilter(params.controlTasks.filter, 'project_id.site_ids', 'child_of', [patrimoine.id]);
                    swif.data.addFilter(params.controlTasks.filter, 'site1', '=', patrimoine.id);
                    swif.data.addFilter(params.contractTasks.filter, 'site1', '=', patrimoine.id);
                } else if (patrimoine._type === 'patrimoine_equipment') {
                    swif.data.addFilter(params.requests.filter, 'equipment_id', '=', patrimoine.id);
                    swif.data.addFilter(params.interventions.filter, 'equipment_id', '=', patrimoine.id);
                    swif.data.addFilter(params.tasks.filter, '|');
                    swif.data.addFilter(params.tasks.filter, 'equipment_id', '=', patrimoine.id);
                    swif.data.addFilter(params.tasks.filter, 'project_id.equipment_id', '=', patrimoine.id);
                    swif.data.addFilter(params.contractTasks.filter, 'project_id.equipment_ids', 'in', [patrimoine.id]);
                    swif.data.addFilter(params.controlTasks.filter, 'project_id.equipment_ids', 'in', [patrimoine.id]);
                    swif.data.addFilter(params.controlTasks.filter, 'equipment_id', '=', patrimoine.id);
                    swif.data.addFilter(params.contractTasks.filter, 'equipment_id', '=', patrimoine.id);
                }
            }
            return params;
        };
        service.getChildren = function (parent_id) {
            var params = {};
            swif.data.sortOn(params, 'name', 'ASC');
            swif.data.addFilter(params, 'site_parent_id', '=', parent_id);
            return swif.data.searchRead('patrimoine_site', params)
            .then(function (sites) {
                return sites.records;
            });
        };
        service.getGauges = function (patrimoine) {
            var gauge = {};
            var rfilter = {};
            swif.data.addFilter(rfilter, 'state', 'in', ['draft', 'wait']);
            var field = 'site1.id';
            if (patrimoine._type === 'patrimoine_equipment') {
                field = 'equipment_id.id';
            }
            swif.data.addFilter(rfilter, field, '=', patrimoine.id);
            swif.data.searchRead('intervention_request', rfilter)
            .then(function (data) {
                gauge.request = data;
                gauge.request.filter = rfilter;
                gauge.request.options = {
                    contentType: 'intervention_request',
                    modal: {
                        title: 'Request',
                        templateUrl: 'partials/patrimoine/requests_table_modal.html'
                    }
                };
            });

            var ifilter = {};
            swif.data.addFilter(ifilter, 'state', 'in', ['open', 'scheduled']);
            swif.data.addFilter(ifilter, 'date_deadline', '<', 'OUTDATED');
            swif.data.addFilter(ifilter, field, '=', patrimoine.id);
            swif.data.searchRead('intervention', ifilter)
            .then(function (data) {
                gauge.intervention = data;
                gauge.intervention.filter = ifilter;
                gauge.intervention.options = {
                    contentType: 'intervention',
                    modal: {
                        title: 'Intervention',
                        templateUrl: 'partials/patrimoine/interventions_table_modal.html'
                    }
                };
            });

            gauge.equipment_and_properties = 0;
            var cfilter = {};
            var cDefer;
            if (patrimoine._type === 'patrimoine_site') {
                swif.data.addFilter(cfilter, 'site_id.id', '=', patrimoine.id);
                swif.data.addFilter(cfilter, 'state', 'in', ['unsuitable', 'dangerous']);
                cDefer = swif.data.searchRead('equipment', cfilter);
            } else {
                cDefer = $q.when(false);
            }

            var sfilter = {};
            if (field === 'site1.id') {
                field = 'site_id.id';
            }
            swif.data.addFilter(sfilter, field, '=', patrimoine.id);
            swif.data.addFilter(sfilter, 'state', 'in', ['unsuitable', 'dangerous']);
            var sDefer = swif.data.searchRead('patrimoine_property', sfilter);
            // i group the both requests, so that equipment_and_properties
            // will be update only once, avoiding problem of a double watch-trigger
            $q.all({c: cDefer, s: sDefer}).then(function (data) {
                if (data.c) {
                    gauge.equipment_and_properties += data.c.length + data.s.length;
                    gauge.equipment = data.c;
                    gauge.equipment.filter = cfilter;
                    gauge.equipment.tabId = 'equipments';
                    gauge.equipment.searchKey = 'equipmentsFilter';
                    gauge.equipment.options = {
                        contentType: 'equipment',
                        modal: {
                            title: 'Equipment',
                            templateUrl: 'partials/patrimoine/equipments_table_modal.html'
                        }
                    };
                }
                gauge.patrimoine_property = data.s;
                gauge.patrimoine_property.filter = sfilter;
                gauge.patrimoine_property.tabId = 'properties';
                gauge.patrimoine_property.searchKey = 'patrimoinePropertiesFilter';
                gauge.patrimoine_property.options = {
                    contentType: 'patrimoine_property',
                    modal: {
                        title: 'Property',
                        templateUrl: 'partials/patrimoine/property_table_modal.html'
                    }
                };
            });

            // @TODO: for 3 filters above, they will stay on intervention context
            // ONLY BECAUSE site_id and equipment_id are not used on 'contract' context
            // We need to add ['|', (project_type', '=', 'intervention'), (project_type, = false)]

            // get controls-contracts whose new task is 'delay passed'
            var contractFilter = {};
            swif.data.addFilter(contractFilter, 'project_type', '=', 'contract');
            if (patrimoine._type === 'patrimoine_site' || patrimoine._type === 'site') {
                swif.data.addFilter(contractFilter, 'site_ids', 'child_of', patrimoine.id);
            } else {
                swif.data.addFilter(contractFilter, 'equipment_ids', 'in', [patrimoine.id]);
            }
            swif.data.addFilter(contractFilter, 'tasks.schedule_delay_passed', '=', true);
            swif.data.searchRead('patrimoine_contract', contractFilter)
            .then(function (data) {
                gauge.control = data;
                gauge.control.filter = contractFilter;
                gauge.control.options = {
                    contentType: 'patrimoine_contract',
                    modal: {
                        title: 'Controls-Contracts',
                        templateUrl: 'partials/patrimoine/contracts_table_modal.html'
                    }
                };
            });
            return gauge;
        };
        service.selectOneFormatNameChoice = function (value) {
            return openbase.utils.selectOneFormatNameChoice(value);
        }
        return service;
    }


    function PatrimoineReferentielController($scope, $timeout, $q, $location, $uibModal, swif, swifPatrimoineReferentielService, data, $rootScope) {
        'ngInject';
        var service = swifPatrimoineReferentielService;
        console.log('init PatrimoineReferentielController');
        $scope.debug = swif.debug;
        $scope.select = data.select;
        // activate 'carnet_de_sante' tab by default
        $scope.activeTab = 0;
        $scope.markerDetailIsSelected = false;
        $scope.data = data;
        $scope.patrimoine_type = data.patrimoine_type;
        $scope.referentiel = data.referentiel;
        if ($scope.referentiel.currentItem && !$scope.referentiel.currentItem.custom_fields) {
            $scope.referentiel.currentItem.custom_fields = [];
        }
        // boolean to manage customFields features
        $scope.patrimonyCustomFields = swif.settings.app.features.patrimonyCustomFields;
        // boolean to manage SIG connector features
        $scope.isSIG = swif.settings.app.features.sigConnector;

        /*** TG-3474-VSN - display initial collection of sites if there is an ongoing research ***/
        $scope.isVSN = swif.settings.app.features.isVSN || false;

        $scope.isResearchOn = {};
        delete $scope.referentiel.currentItems;
        delete $scope.referentiel.currentItem;
        // Check if research is activated by looking at filters and listening to filter changes
        $scope.referentiel.currentFilter.filters = {};
        $scope.selectedMarkersList = [];
        $scope.isResearchOn.on, $scope.showSelectedMarkers = false;
        $scope.user = swif.user.getAuthenticatedUserData();
        $scope.access_rights = swif.user.getAccessRights();

        $scope.$watch('referentiel.currentFilter.filters', function(newV) {
            // If ongoing research
            if (newV != undefined && newV.text) {
                $scope.isResearchOn.on = true;
                $scope.showSelectedMarkers = false;
            // If reset search - display default map layer
            } else {
                $scope.isResearchOn.on = false;
            }
            $scope.selectedMarkersList = [];
            $scope.markerDetailIsSelected = false;

            $scope.referentiel.currentItems = $scope.selectedMarkersList;
            $scope.$broadcast('markerIsDeselected', $scope.selectedMarkersList);
        }, true);

        // TG3637-VSN & TG3941 - Visualize details from tabs
        $scope.$on('onClickDetailSite', function(data, site) {
            $timeout(function() {
                $scope.markerDetailIsSelected = true;
                // Active "attributes" tab
                var attributTab = 8;
                $scope.activeTab = attributTab;
                $scope.referentiel.currentItem = site;
            });
        });

        $scope.$on('closeTabs', function(data) {
            $scope.$apply(function(){
                $scope.markerDetailIsSelected = false;
                $scope.referentiel.currentItems = [];
            });
        });

        // Listen to signal updating the list of selected markers, to be displayed in the sidebar
        $scope.$on('markerIsSelected', function(data, selectedMarkersList) {
            $scope.showSelectedMarkers = (selectedMarkersList.length > 0) ? true : false;
            $timeout(function(){
                $scope.selectedMarkersList = selectedMarkersList;
                $scope.referentiel.currentItems = selectedMarkersList;
                if (selectedMarkersList.length > 0) {
                    $scope.referentiel.currentItem = selectedMarkersList[0];
                } else if (selectedMarkersList.length > 1) {
                    $scope.referentiel.currentItems = selectedMarkersList;
                } else if (selectedMarkersList.length === 0) {
                    delete $scope.referentiel.currentItems;
                    delete $scope.referentiel.currentItem;
                }
            });
        });

        $scope.$watch('patrimoine_type', function (newV) {
            $location.search('patrimoine_type', newV);
            if (newV && $scope.referentiel) {
                if ($scope.referentiel.contentType !== newV) {
                    $scope.referentiel.contentType = newV;
                    delete $scope.referentiel.currentItem;
                    $scope.referentiel.currentFilter = service.getCollectionFilter(newV);
                    $scope.suiviParams = service.getSuiviParams();
                    $scope.selectedSites = []
                }
            }
        });
        $scope.gauge = {value: 19};
        $scope.preModal = preModal;
        $scope.preValidate = preValidate;
        $scope.callback = callback;
        $scope.parents = [];
        $scope.modules = swif.module.modules;
        $scope.suiviParams = service.getSuiviParams($scope.referentiel.currentItem);
        $scope.selectedSites = []
        $scope.onClickCurrentItem = onClickCurrentItem;
        function onClickCurrentItem(item, sites) {
            $rootScope.$broadcast('onClickCurrentItemToOpenPopupMap', item, sites);
        }

        $scope.toggleSite = function (site) {
            if(site._type != 'patrimoine_site'){
                return;
            }
            site._active = !site._active;
            if (site._active) {
                $scope.selectedSites.push(site)
            } else {
                _.remove($scope.selectedSites, function(s) {
                    return s.id == site.id;
                });
            }
        }

        $scope.removeSiteFromSelected = function (site) {
            _.remove($scope.selectedSites, function(s) {
                return s.id == site.id;
            });
            for (const s of $scope.referentiel.items) {
                if (site.id == s.id) {
                    s._active = false
                }
            }
        }

        // TG-3474-VSN - deselect marker from sidebar
        if ($scope.isVSN) {
            // Remove site from list and send to map
            $scope.deselectMarker = deselectMarker;
            function deselectMarker(siteID) {
                $scope.selectedMarkersList = $scope.selectedMarkersList.filter((site) => site.id !== siteID);
                $scope.referentiel.currentItems = $scope.selectedMarkersList;
                $scope.$broadcast('markerIsDeselected', $scope.selectedMarkersList, siteID);
                // Use referentiel function to set current item
                $scope.referentiel.setCurrent($scope.selectedMarkersList[0] ? $scope.selectedMarkersList[0].id : null)
            }
        }

        function preModal(data) {
            if (data.action.id === 'add') {
                swif.data.callKw('equipment', 'increment_equipment_reference').then(function (res) {
                    if (res.next_equipment_ref && _.isNumber(res.next_equipment_ref)) {
                        data.model.equipment_reference = res.next_equipment_ref;
                    }
                });
            }
            return service.preModal(data);
        }

        function preValidate(data) {
            if (
                data.model._type === 'patrimoine_equipment' &&
                data.model.equipment_reference != undefined &&
                data.model.equipment_reference === 0
            ) {
                delete data.model.equipment_reference;
            }
            return service.preValidate(data);
        }

        function callback(error, data) {
            if (error) {
                return;
            }
            var model, action;

            // Set current site to intervention or intervention request
            function prepareModel(data) {
                if (data.model._type === 'patrimoine_site' || data.model._type === 'site') {
                    return {
                        site1: [data.model.id, data.model.name]
                    };
                } else if (data.model._type === 'patrimoine_equipment') {
                    return {
                        site1: data.model.site_id,
                        equipment_id: [data.model.id, data.model.name]
                    };
                }
            }
            function prepareModelMultiple(data) {
                let model = {
                    _tasks: [],
                    create_task:true,
                }
                let gestionnaireDEP
                data.forEach(function (site, counter) {
                    // site.custom_fields can be false
                    var customFields = site.custom_fields || [];

                    // TG3761 - fill site and service fields with the first site selected
                    // when multiple sites are selected from map
                    if (counter === 0) {
                        model.site1 = [site.id, site.name];
                        if ($scope.isVSN) {
                            model.custom_fields = customFields
                        }
                    }
                    customFields.map((customField) => {
                        if (customField.key === 'Gestionnaire DEP') {
                            gestionnaireDEP = customField.value
                        }
                    });
                    model._tasks.push({
                        planned_hours: 2,
                        _id: counter,
                        _collapsed: false,
                        site1: [site.id, site.name],
                        customField: gestionnaireDEP
                    })
                })
                return model;
            }
            function prepareModelControlContract(data) {
                let siteIds = []
                data.forEach(function (site) {
                    siteIds.push(site.id)
                })
                return { site_ids: siteIds }
            }
            function _callback(error, data) {
                swif.collections.defaultCallbackMessage(error, data);
            }
            // Format associated task after intervention form validation
            function interventionPreValidate(data) {
                var validated = swif.collections.preValidate(data);
                if (data.action.id === 'add') {
                    //handle create_task
                    if (data.model.create_task && data.model._tasks.length) {
                        var tasks = angular.copy(data.model._tasks);
                        var deferred = [];
                        delete data.model._tasks;
                        data.model.tasks = [];
                        angular.forEach(tasks, function(task) {
                        var siteOnTaskFeature = swif.settings.app.features.siteOnTask;
                            if (siteOnTaskFeature) {
                                task.has_site_on_task_feature = siteOnTaskFeature;
                            }
                            var ctask = angular.copy(task);

                            // Duplicate from intervention service, because no other solution atm
                            if (Array.isArray(ctask.user_id) && Number.isInteger(ctask.user_id[1])) {
                                // Duplicate task with main attribute when multiple user_ids
                                var user_ids = ctask.user_id;
                                ctask.user_id = [user_ids.shift(), ''];
                                for (const id of user_ids) {
                                    var dupTask = angular.copy(ctask);
                                    dupTask.user_id =  [id, ''];
                                    // Remove useless attributes for secondary tasks
                                    delete dupTask.consumable_request_ids
                                    delete dupTask.consumable_asks
                                    delete dupTask.consumables
                                    delete dupTask.vehicule
                                    delete dupTask.equipment_ids
                                    delete dupTask.purchase_order
                                    delete dupTask.oil_price
                                    delete dupTask.oil_qtity
                                    delete dupTask.km
                                    deferred.push(swif.data.sanitizeData('task', dupTask).then(function(stask) {
                                        data.model.tasks.push([0, 0, stask]);
                                        return true;
                                    }));
                                }
                            }
                            deferred.push(swif.data.sanitizeData('task', ctask).then(function(stask) {
                                data.model.tasks.push([0, 0, stask]);
                                return true;
                            }));
                        })
                        return $q.all(deferred).then(function() {
                            return true;
                        });
                    }
                }
                return validated;
            }
            if (data.action.id === 'add_intervention_request') {
                model = prepareModel(data);
                if (data.model.custom_fields && Object.keys(data.model.custom_fields).length > 0) {
                    data.model.custom_fields.map((customField) => {
                        if (customField.key === 'Gestionnaire DEP') {
                            model.custom_fields = customField.value
                        }
                    });
                }
                action = swif.action.getActionById(
                    'intervention_request',
                    'list', 'add'
                );
                swif.action.dispatch(
                    'intervention_request', action, model,
                    {callback: _callback}
                );
            } else if (data.action.id === 'add_intervention') {
                if ($scope.isVSN) {
                    if ($scope.referentiel.currentItems.length > 1){
                        model = prepareModelMultiple($scope.referentiel.currentItems)
                        if (model.custom_fields) {
                            model.custom_fields.map((customField) => {
                                if (customField.key === 'Gestionnaire DEP') {
                                    model.custom_fields = customField.value
                                }
                            });
                        }
                    } else if ($scope.selectedSites.length > 1) {
                        model = prepareModelMultiple($scope.selectedSites)
                        if (model.custom_fields) {
                            model.custom_fields.map((customField) => {
                                if (customField.key === 'Gestionnaire DEP') {
                                    model.custom_fields = customField.value
                                }
                            });
                        }
                    } else {
                        model = prepareModel(data)
                        if (data.model.custom_fields && Object.keys(data.model.custom_fields).length > 0) {
                            data.model.custom_fields.map((customField) => {
                                if (customField.key === 'Gestionnaire DEP') {
                                    model.custom_fields = customField.value
                                }
                            });
                        }
                    }
                } else {
                    if ($scope.selectedSites.length > 1) {
                        model = prepareModelMultiple($scope.selectedSites)
                    } else {
                        model = prepareModel(data)
                    }
                }
                action = swif.action.getActionById(
                    'intervention',
                    'list', 'add'
                );
                swif.action.dispatch(
                    'intervention', action, model,
                    {
                        callback: callback,
                        preValidate: interventionPreValidate
                    }
                );
            } else if (data.action.id === 'add_control_contract') {
                if ($scope.selectedSites.length > 1) {
                    model = prepareModelControlContract($scope.selectedSites);
                } else {
                    model = prepareModelControlContract($scope.referentiel.currentItems);
                }
                let gestionnaireDEP = ''
                for (const item of $scope.referentiel.currentItems){
                    if (item.custom_fields) {
                        item.custom_fields.map((customField) => {
                            if (customField.key === 'Gestionnaire DEP') {
                                if (gestionnaireDEP === '') {
                                    gestionnaireDEP = customField.value
                                }
                                if (gestionnaireDEP !== customField.value || customField.value === undefined) {
                                    gestionnaireDEP = undefined
                                    return false
                                }
                            }
                        });
                        if (gestionnaireDEP === undefined) {
                            break
                        }
                    } else {
                        gestionnaireDEP = undefined
                        break
                    }
                }
                model.custom_fields = gestionnaireDEP
                action = swif.action.getActionById(
                    'patrimoine_contract',
                    'list', 'add'
                );
                swif.action.dispatch(
                    'patrimoine_contract', action, model,
                    {
                        callback: callback,
                        preValidate: interventionPreValidate
                    }
                );
            } else {
                // TG3046 - In case we try to create a task and not an intervention
                // we don't want to use callback function
                if(data.action.title !== 'Add intervention'){
                    service.callback(error, data);
                }
            }
        }

        $scope.tab = {};
        var selectedTab = $location.search().currentTab;
        if(selectedTab) {
            $scope.tab[selectedTab] = true;
        }
        // callback when a tab is activated => update the URL 'currentTab'
        $scope.onTabActive = function (item) {
            $location.search('currentTab', item);
            $scope.tab[item] = true;
        };

        // @TODO: we should define the .modal* methods in a different controller,
        //  that will be injected in this one
        // for now, $scope.modal store ALL elements that will be the scope of
        // the $uibModal instance
        $scope.modal = {};
        // @param setting: can be either $scope.gauge.equipment or $scope.gauge.patrimoine_property
        // @note: open the related modal (based on setting values)
        $scope.openEquipmentsOrPropertiesModal = function (setting) {
            var params = angular.copy(setting.options.modal);
            var filter = angular.copy(setting.filter);
            // supply all $scope.modal to the $uibModal instance scope
            // i first create a new isolated scope for the modal,
            // because modal needs a scope instance
            var modalParams = angular.copy(params);
            params.scope = $scope.$new(true);
            _.merge(params.scope, $scope.modal);
            params.size = params.size || 'lg';
            // store the current selected setting in current scope,
            // but not in the modal scope (not needed)
            $scope.modal.setting = setting;
            // useless ? :
            // params.templateUrl = scope.options.modal.templateUrl;
            swif.collections.createOrUpdate(
                'swif-open-filter-in-modal',
                setting.options.contentType, filter, {limitPerPage: 10}
            ).then(function (collection) {
                modalParams.collection = collection;
                // i still use scope.modalParams to remaing i the same
                // format as the filter-service original behavior
                params.scope.modalParams = modalParams;
                $scope.modal.modalInstance = $uibModal.open(params);
            });
        };

        // this method is simiar to openInModule in filter service,
        //  but specific to this view (will open the related tab
        //  and specify the filter to apply on the sub-collection)
        $scope.modal.openInTab = function () {
            $scope.modal.closeModal();
            var setting = $scope.modal.setting;
            if (setting) {
                if (setting.searchKey) {
                    $location.search(setting.searchKey, JSON.stringify(setting.filter));
                }
                if (setting.tabId) {
                    // if tabId is supplied, activate the related tab
                    $scope.tab[setting.tabId] = true;
                }
            } else {
                console.warning('openInTab() Error: no setting found in $scope.modal.setting');
            }
        };

        $scope.modal.closeModal = function () {
            $scope.modal.modalInstance.close();
        };

        $scope.children = [];
        var updateGauges = function () {
            $scope.gauge = service.getGauges($scope.referentiel.currentItem);
        };
        $scope.$watch('referentiel.items', function (newV, oldV) {
            for (const s of $scope.referentiel.items) {
                if (_.any($scope.selectedSites, 'id', s.id)) {
                    s._active = true
                }
            }
        });
        $scope.$watch('referentiel.currentItem', function (newV, oldV) {
            if (oldV && newV) {
                if (oldV.id === newV.id) {
                    return;
                }
            }
            if (!newV) {
                return;
            }
            $scope.suiviParams = service.getSuiviParams(newV);
            service.getChildren(newV.id).then(function (sites) {
                $scope.children = sites;
            });
            updateGauges();
        });
        $scope.editMode = false;
        $scope.toggleEditMode = function () {
            $scope.editMode = !$scope.editMode;
        };
        $scope.mass_add = {};
        $scope.massAdd = function () {
            var o = $scope.mass_add;
            var current = $scope.referentiel.currentItem;
            var start = o.start_at;
            var end = o.qtt + o.start_at;
            var prefix = o.prefix || '';
            var ob = {};
            var promises = [];
            for (var i = start; i < end; i++){
                ob.name = '' + prefix + ' ' + i;
                ob.site_parent_id = [
                    current.id,
                    current.name
                ];
                ob.type_ids = o.type_ids;
                console.log(ob.name);
                promises.push(swif.data.create('patrimoine_site', ob));
            }
            $q.all(promises).then(function () {
                service.getChildren($scope.referentiel.currentItem.id);
                swif.message.addInfo('Item has been added successfully');
            });
        };
    }


    function listGroupItemPatrimoineSite() {
        return {
            restrict: 'A',
            replace: true,
            scope: {
                listGroupItemPatrimoineSite: '='
            },
            templateUrl: 'partials/patrimoine/list-group-item-patrimoine-site.html'
        };
    }


})();
